import store from '@/store';
import { EntityTypes } from '@/types/entities';

export default class StudyListingOverviewComponent {
	public get campaignId(): number {
		return store.getters.campaignId();
	}

	private get studyId(): number {
		return store.getters.studyId();
	}

	public mounted(): void {
		store.mutations.markEntityAsSelected({
			type: EntityTypes.STUDY,
			id: this.studyId,
			title: '',
			degreeType: '',
			degreeName: '',
			targetingGroup: 0,
			pricingGroup: 0
		});
	}
}
